import React, { PureComponent } from 'react';

import FieldSelect from './FieldSelect';

class FieldsHelper extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isVisible: this.props.isVisible
        };
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.isVisible !== nextProps.isVisible) {
            this.setState({isVisible: nextProps.isVisible});
        }
    }

    handleFieldButtonClick = (value) => {
        this.props.addFieldValueToInput(value, this.props.targetInput);
    }

    handleShowHide = (e) => {
        this.setState({isVisible: !this.state.isVisible});
    }

    render() {
        const activeClass = this.state.isVisible ? " active" : ""
              , fieldSelects = this.props.fieldSelects
              , selectColumns = 12 / fieldSelects.length;

        return (
            <div className="noFont">
                <div className={"fieldsHelperHolder" + activeClass}>
                    <div className="row">
                        {
                            fieldSelects.map((select, index) =>
                                <FieldSelect
                                    key={index}
                                    selectId={select.selectId}
                                    selectText={select.selectText}
                                    selectColumns={selectColumns}
                                    selectOptions={select.selectOptions}
                                    disabled={this.props.disabled}
                                    handleFieldButtonClick={this.handleFieldButtonClick} />
                            )
                        }
                    </div>
                </div>
                <button type="button" className="fieldHelperButton" onClick={this.handleShowHide}>{!this.state.isVisible ? "Ver campos de sistema" : "Esconder campos de sistema"} <i className="fa fa-chevron-down"></i></button>
            </div>
        );
    }
}

export default FieldsHelper;
